<template>
  <div>
    <el-progress
      :percentage="value"
      :type="progressType"
      :color="color"
      v-bind="attribute"
    ></el-progress>
    <div class="date">
      <div class="startDate" v-if="startDate">{{ startDate }}</div>
      <div class="endDate" v-if="endDate">{{ endDate }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    progressType: {
      type: String,
      default: 'line',
    },
    color: {
      type: String,
      default: '#3da1ff',
    },
    startDate: {
      type: [String, Number],
    },
    endDate: {
      type: [String, Number],
    },
    attribute: {
      type: Object,
    },
  },
  data() {
    return {}
  },
  methods: {},
  components: {},
}
</script>

<style lang="scss" scoped>
.date {
  width: 100%;
  padding: 0 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
